import scansSchema from './scansSchema'

const gtinFormSchema = (t) => scansSchema(t)

export default gtinFormSchema
